import {
    AuthData,
    AuthDataRaw,
    Profile,
    ProfileRaw,
    TokensData,
    TokensDataRaw,
    UserPermissionValue,
} from 'types';

export function parseProfile(profile: ProfileRaw): Profile {
    return {
        username: profile.username,
        email: profile.email,
        emailVerified: profile.emailVerified,
        firstName: profile.firstName,
        lastName: profile.lastName,
        fullName: profile.fullName,
        permissions: profile.authorities as Array<UserPermissionValue>,
        signEds: profile.signEds,
        roles: profile.roles,
        client: profile.client,
        clientId: profile.clientId,
        legalPerson: profile.legalPerson,
        phone: profile.phone,
    };
}

export function parseTokensData(tokensData: TokensDataRaw): TokensData {
    return {
        accessToken: tokensData.accessToken,
        refreshToken: tokensData.refreshToken,
        accessTokenExpiresIn: new Date(tokensData.accessExpiresAt),
        refreshTokenExpiresIn: new Date(tokensData.refreshExpiresAt),
    };
}

export function parseAuthData(authData: AuthDataRaw): AuthData {
    return {
        ...parseTokensData(authData),
        profile: parseProfile(authData.profile),
    };
}
